module.exports = __webpack_public_path__ + "static/media/mx5-hero.b7e52fc1.jpg";